<template>
  <div class="bg">
    <div class="infoWrapper">
      <div class="infoBox">
        <div class="infoLine">
          <div class="infoTitle avatar">头像</div>
          <div class="infoAvatar" v-if="userInfo.avatar">
            <img :src="userInfo.avatar" />
          </div>
          <div class="infoAvatar" v-else>
            <img src="../../assets/avatar.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="infoWrapper">
      <div class="infoBox">
        <div class="infoLine flex">
          <div class="infoTitle">名称</div>
          <div class="infoText flex1">
            <input v-model="userInfo.name" placeholder="输入账户昵称" />
          </div>
        </div>
        <div class="infoBox">
          <Address v-model="userInfo.addrCode"></Address>
          <div class="infoLine flex">
            <div class="infoTitle">详细地址</div>
            <div class="infoText flex1">
              <input placeholder="详细地址" v-model="userInfo.addrDetail" />
            </div>
          </div>
        </div>
        <div class="infoLine flex">
          <div class="infoTitle">认证状态</div>
          <div class="infoText flex1">
            <span
              v-if="userInfo.verifyTwoCitizen == 0"
              class="idcard-identity unIdentity"
              @click="goIdentity"
              >未认证</span
            >
            <span
              v-else-if="userInfo.verifyTwoCitizen == 1"
              class="idcard-identity identity"
              >已认证</span
            >
            <span v-else class="idcard-identity identity"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="saveButton" @click="submit">
      <span style="width: 100%;height: 100%;display: block;">
        保存
      </span>
    </div>
    <confirm
      v-model="show"
      title="提示"
      confirm-text="确定"
      @on-cancel="onCancel"
      @on-confirm="onConfirm"
    >
      <p style="text-align:center;">当前页面还有未保存数据，是否前往认证？</p>
    </confirm>
  </div>
</template>

<script>
import { getClientDetail, informationSubmit } from "../../api/client.js";
import Address from "../../components/Address/address";

export default {
  components: {
    Address
  },
  data() {
    return {
      userInfo: {
        avatar: "",
        name: "",
        addrCode: "",
        addrDetail: ""
      },
      orignalUserInfo: "",
      uploadLoading: false,
      show: false
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    onCancel() {
      this.show = false;
    },
    onConfirm() {
      this.$router.push({ path: "/user/identity" });
    },
    submit() {
      this.$vux.loading.show();
      informationSubmit(this.userInfo)
        .then(() => {
          this.$vux.loading.hide();
          this.$router.push({ path: "/profile" });
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showError(err);
        });
    },
    goIdentity() {
      if (
        this.userInfo.avatar == this.orignalUserInfo.avatar &&
        this.userInfo.name == this.orignalUserInfo.name &&
        this.userInfo.addrCode == this.orignalUserInfo.addrCode &&
        this.userInfo.addrDetail == this.orignalUserInfo.addrDetail
      ) {
        this.$router.push({ path: "/user/identity" });
      } else {
        this.show = true;
      }
    },
    getUserInfo() {
      getClientDetail()
        .then(res => {
          this.userInfo = res;
          this.orignalUserInfo = JSON.parse(JSON.stringify(res));
        })
        .catch(err => {
          this.$showError(err);
        });
    }
  }
};
</script>

<style scoped>
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
input {
  width: 100%;
  border: none;
  background: #fff;
}
.uploadInput {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.popWrapper {
  background: #fff;
  border-radius: 8px;
  width: 600px;
  overflow: hidden;
}

.title1 {
  width: 100%;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  text-align: center;
  color: #262626;
}
.text1 {
  margin: 20px 30px;
  font-size: 16px;
  line-height: 48px;
}
.buttonBox {
  margin: 30px 30px;
  overflow: hidden;
}

.cancelButton {
  float: left;
  width: 220px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid rgba(198, 198, 198, 1);
  color: #777777;
  background: #fff;
  font-size: 15px;
}

.confirmButton {
  float: right;
  width: 220px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background: #1573ff;
  color: #fff;
  border-radius: 10px;
  border: 1px solid rgba(21, 115, 255, 1);
  font-size: 15px;
}
.identity {
  color: #4695fb;
  background: rgba(220, 235, 254, 1);
  border: 1px solid rgba(158, 197, 253, 1);
}
.unIdentity {
  color: #eb8f8f;
  background: #feeeee;
  border: 1px solid #eb8f8f;
}
.uploadWrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
}
.idcard-identity {
  font-size: 10px;
  border-radius: 30px;
  padding: 0 10px;
  margin-left: 12px;
  line-height: 30px;
}
.bg {
  background: #f3f3f3;
}
.infoWrapper {
  margin: 20px 0;
  overflow: hidden;
}
.infoBox {
  overflow: hidden;
  margin-bottom: 20px;
}

.infoLine {
  overflow: hidden;
  padding: 30px;
  background: #fff;
  border-bottom: 1px solid #f1f1f1;
}

.infoTitle {
  width: 140px;
  font-size: 14px;
  line-height: 30px;
  color: #525252;
}

.avatar {
  line-height: 90px;
  display: block;
  float: left;
}

.infoAvatar {
  width: 86px;
  height: 86px;
  border-radius: 46px;
  border: 1px solid #eaeaea;
  float: right;
  overflow: hidden;
  position: relative;
}

.infoAvatar img {
  width: 100%;
  height: 100%;
}

.infoText {
  text-align: right;
  font-size: 14px;
  line-height: 28px;
  color: #262626;
}

.infoText input {
  line-height: 28px;
  font-size: 14px;
  width: 100%;
  text-align: right;
}
.iconArrow {
  width: 20px;
  height: 28px;
  margin-left: 10px;
}
.saveButton {
  margin: 30px;
  background: #007bec;
  height: 86px;
  line-height: 86px;
  text-align: center;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  letter-spacing: 20px;
}

.loadingImg {
  width: 32px;
  height: 32px;
  line-height: 86px;
}

.success {
  margin: 0 auto;
  text-align: center;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  color: red;
}
.weui-cells {
  margin-top: 0;
}
</style>
